if (!customElements.get('sey-selling-points')) {
  customElements.define(
    'sey-selling-points',
    class SeySellingPoints extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-selling-points-track]');
        this.slides = Array.from(this.querySelectorAll('[data-selling-points-slide]'));
        this.prevButton = this.querySelector('[data-selling-points-prev]');
        this.nextButton = this.querySelector('[data-selling-points-next]');
        this.progress = this.querySelector('[data-selling-points-progress]');
        this.progressFill = this.querySelector('[data-selling-points-progress-fill]');
        this.index = 0;
        this.scrolling = false;

        if (!this.track || this.slides.length < 2) return;

        this.go = this.go.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.prevButton?.addEventListener('click', () => this.go(-1));
        this.nextButton?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      go(delta) {
        const next = Math.min(this.slides.length - 1, Math.max(0, this.index + delta));
        if (next === this.index) return;
        this.index = next;
        this.scrollToIndex();
        this.update();
      }

      scrollToIndex() {
        const slide = this.slides[this.index];
        if (!slide) return;
        this.scrolling = true;
        this.track.scrollTo({
          left: this.slideLeft(slide),
          behavior: 'smooth',
        });
        window.setTimeout(() => {
          this.scrolling = false;
        }, 400);
      }

      slideLeft(slide) {
        const pad = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
        return slide.offsetLeft - pad;
      }

      nearestIndex() {
        const current = this.track.scrollLeft;
        let nearest = 0;
        let distance = Number.POSITIVE_INFINITY;
        this.slides.forEach((slide, index) => {
          const delta = Math.abs(this.slideLeft(slide) - current);
          if (delta < distance) {
            distance = delta;
            nearest = index;
          }
        });
        return nearest;
      }

      onScroll() {
        if (this.scrolling) return;
        const next = this.nearestIndex();
        if (next === this.index) return;
        this.index = next;
        this.update();
      }

      onResize() {
        this.track.scrollTo({
          left: this.slideLeft(this.slides[this.index]),
          behavior: 'auto',
        });
      }

      update() {
        const total = this.slides.length;
        const atStart = this.index === 0;
        const atEnd = this.index === total - 1;

        if (this.prevButton) this.prevButton.disabled = atStart;
        if (this.nextButton) this.nextButton.disabled = atEnd;
        if (this.progress) this.progress.setAttribute('aria-valuenow', String(this.index + 1));
        if (this.progressFill) {
          this.progressFill.style.width = `${((this.index + 1) / total) * 100}%`;
        }
      }
    }
  );
}
